import { SxProps, Theme } from '@mui/material';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';

interface LoadPhaseColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function LoadPhaseColumn({ load, sx }: LoadPhaseColumnProps) {
  const phase = load.phase;

  return (
    <FlexColumn sx={sx}>
      <OverflowAwareText sx={{ fontWeight: 600 }}>{phase?.name ?? '-'}</OverflowAwareText>

      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {phase?.code ?? '-'}
      </OverflowAwareText>
    </FlexColumn>
  );
}
